import React from 'react';
import type { Service } from '../../../../../../shared/types/config';

interface CategoriesSpeItem {
  id: number;
  nom: string;
  id_service: number;
  ordre: number;
  actif: number;
  service_nom?: string;
}

interface CategoriesSpeTabProps {
  t: (key: string) => string;
  loading: boolean;
  services: Service[];
  categoriesSpecialite: CategoriesSpeItem[];
  newCategorieSpeNom: string;
  setNewCategorieSpeNom: React.Dispatch<React.SetStateAction<string>>;
  newCategorieSpeServiceId: number;
  setNewCategorieSpeServiceId: React.Dispatch<React.SetStateAction<number>>;
  creatingCategorieSpe: boolean;
  handleCreateCategorieSpe: () => void;
}

const inputCls = 'rounded-lg border border-[#223046] bg-[#0b1220] px-3 py-2 text-sm text-cockpit-text placeholder-cockpit-muted focus:outline-none focus:border-[#6366f1]/60';

const CategoriesSpeTab: React.FC<CategoriesSpeTabProps> = ({
  t,
  loading,
  services,
  categoriesSpecialite,
  newCategorieSpeNom,
  setNewCategorieSpeNom,
  newCategorieSpeServiceId,
  setNewCategorieSpeServiceId,
  creatingCategorieSpe,
  handleCreateCategorieSpe,
}) => (
  <div className="space-y-6">
    <div>
      <h2 className="text-sm font-semibold text-cockpit-text mb-3">{t('categoriesSpe.addTitle')}</h2>
      <p className="text-xs text-cockpit-text-2 mb-3">{t('categoriesSpe.addDescription')}</p>
      <div className="flex flex-col sm:flex-row gap-3 flex-wrap">
        <input
          type="text"
          value={newCategorieSpeNom}
          onChange={(e) => setNewCategorieSpeNom(e.target.value)}
          placeholder={t('categoriesSpe.placeholder')}
          className={`flex-1 min-w-[200px] ${inputCls}`}
        />
        <select
          value={newCategorieSpeServiceId || ''}
          onChange={(e) => setNewCategorieSpeServiceId(Number(e.target.value))}
          className={`min-w-[180px] ${inputCls}`}
        >
          <option value={0}>— {t('categoriesSpe.selectService')} —</option>
          {services.map((s) => (
            <option key={s.id} value={s.id}>{s.nom}</option>
          ))}
        </select>
        <button
          type="button"
          onClick={handleCreateCategorieSpe}
          disabled={creatingCategorieSpe}
          className="rounded-lg border border-[#6366f1]/40 bg-[#6366f1]/20 px-5 py-2 text-sm font-semibold text-[#c7d2fe] hover:bg-[#6366f1]/30 transition-colors disabled:opacity-50"
        >
          {creatingCategorieSpe ? t('categoriesSpe.adding') : t('categoriesSpe.add')}
        </button>
      </div>
    </div>
    <div className="border-t border-[#1a2537] pt-4">
      <h2 className="text-sm font-semibold text-cockpit-text mb-3">{t('categoriesSpe.listTitle')}</h2>
      {loading ? (
        <p className="text-sm text-cockpit-muted">{t('categoriesSpe.loading')}</p>
      ) : categoriesSpecialite.length === 0 ? (
        <p className="text-sm text-cockpit-muted">{t('categoriesSpe.empty')}</p>
      ) : (
        <ul className="divide-y divide-[#1a2537]">
          {[...categoriesSpecialite].sort((a, b) => a.nom.localeCompare(b.nom, 'fr')).map((c) => (
            <li key={c.id} className="py-2 flex justify-between text-cockpit-text">
              <span>{c.nom}{c.service_nom ? ` (${c.service_nom})` : ''}</span>
              <span className="text-xs text-cockpit-muted">ID: {c.id}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  </div>
);

export default CategoriesSpeTab;
